module.exports = __webpack_public_path__ + "static/img/ex06.f393a380.png";